module.exports = __webpack_public_path__ + "static/media/ic_location_on_white_24px.181730c7.svg";